export default __webpack_public_path__ + "static/media/complementary--two-way-traffic--g3.46b191f8.png";